<template>
  <div class="myTable">
    <div class="searchNav" >
      <span><span class="searchNameStyle">订单号 ：</span><el-input v-model="searchInfo.title" clearable placeholder="请输入"></el-input></span>
      <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName"  max-height="600px"  @row-dblclick="handleRowDblClick">
        <el-table-column
                type="index"
                width="50">
        </el-table-column>
        <el-table-column prop="title" label="订单号"></el-table-column>
        <el-table-column prop="createTime" label="客户"></el-table-column>
        <el-table-column prop="createTime" label="地址"></el-table-column>
        <el-table-column prop="createTime" label="剩余桶数"></el-table-column>
        <el-table-column prop="createTime"  label="生成时间"></el-table-column>
        <el-table-column
                fixed="right"
                label="操作"
                width="250">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-if="$can('feedback-stat:view')" @click="showInfo(scope.row)">详情</el-button>
            <el-button type="text" size="small" v-if="$can('feedback-stat:edit')" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" v-if="$can('feedback-stat:remove')" @click="confirmRemove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>
    <div>
      <el-dialog
              :title="dialogTitle"
              :closeOnClickModal="false"
              :visible.sync="dialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div class="addInfoStyle">
          <div><span class="required-star">*</span> <span>标题：</span><el-input v-model="addInfo.title" placeholder="请输入" clearable  style="width: 80%;" ></el-input></div>
<!--          <div><span>提交的时间：</span>-->
<!--            <el-date-picker-->
<!--                    v-model="addInfo.feedbackDate"-->
<!--                    type="date"-->
<!--                    value-format="yyyy-MM-dd"-->
<!--                    placeholder="选择日期">-->
<!--            </el-date-picker></div>-->
          <div><span class="required-star">*</span> <span>反馈内容：</span>
            <RichTextEditor @updateContent="handleContentChange" :initialContent="addInfo.content"></RichTextEditor>
          </div>
<!--          <div><span>处理结果：</span><el-input v-model="addInfo.response" placeholder="请输入" clearable></el-input></div>-->
<!--          <div><span>处理状态：</span><el-input v-model="addInfo.status" placeholder="请输入" clearable></el-input></div>-->
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" v-loading="formLoading" @click="save">提 交</el-button>
              </span>
      </el-dialog>
    </div>
    <div>
      <el-dialog
              title="意见反馈详情"
              :visible.sync="infoDialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div class="addInfoStyle">
          <div><span>标题：</span>{{addInfo.title}}</div>
          <div><span>反馈内容：</span>
            <div v-html="addInfo.content"></div>
          </div>
        </div>

      </el-dialog>
    </div>
  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import RichTextEditor from '../util/RichTextEditor';

  export default {
    name: "white-list",
    components: {
      RichTextEditor
    },
    data () {
      return {
        dialogTitle:'新增意见反馈',
        total:1,
        tableData: [],
        loading: false,
        formLoading: false,
        dialogVisible: false,
        infoDialogVisible: false,
        currentPage:1,
        roleList:'',
        addInfo:{
          employeesId:'',
          title:'',
          feedbackDate:'',
          content:'',
          response:'',
          status:''
        },
        searchInfo:{
          title:'',
          pageNumber:1,
          pageSize:50,
        },
      }
    },
    watch: {
      'searchInfo.title'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
    },
    created: function () {
      this.pageInfo();
    },
    methods:{
      search(){
        this.pageInfo();
      },
//改为全局方法
      // 获取编辑器中的内容
      handleContentChange(newContent) {
        this.addInfo.content = newContent;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val ;
        this.pageInfo();
      },
      validate(){

        let flag = true;
        let msg  = "";
        if (this.addInfo.title == ''){
          flag = false;
          msg = " 公告标题不能为空 "
          return {code:flag,msg:msg}
        }
        let contentTxt = this.addInfo.content.replace(/<[^>]*>/g, '');
        if (contentTxt == ''){
          flag = false;
          msg = " 公告内容不能为空 "
          return {code:flag,msg:msg}
        }
        return {code:flag,msg:msg}
      },
      save(){
        if (this.formLoading)  return; // 防止重复提交
        this.formLoading=true;
        let validateData = this.validate();
        if(!validateData.code){
          this.$message({
            message: validateData.msg,
            type: 'warning'
          });
          return;
        }
        if(typeof(this.addInfo.id)=== "undefined" || this.addInfo.id == ''){  // 保存
            axios.post('/feedback',this.addInfo).then(result => {
              this.formLoading=false;
              this.dialogVisible = false;
              if (result.code !== 200){
                console.log(result);
              }
              this.clearObj(this.addInfo); // 清空新增数据
              this.pageInfo();
            }).catch(err => {
              this.formLoading=false;
              console.log(err);
            });
        }else{  // 编辑
            // 当前系列 是开启的
            axios.put('/feedback',this.addInfo).then(result => {
              this.formLoading=false;
              this.dialogVisible = false;
              if (result.code !== 200){
                console.log(result);
              }
              this.pageInfo();

              this.clearObj(this.addInfo); // 清空新增数据
              this.addInfo.id = undefined;
              this.dialogTitle="新增意见反馈";
            }).catch(err => {
              this.formLoading=false;
              console.log(err);
            });
        }
      },
      remove(id){
        axios.delete('/feedback',{data: {id:id}}).then(result => {
          if (result.code !== 200){
            console.log(result);
          }
          this.pageInfo();
        })
      },
      confirmRemove(id){
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.remove(id);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleClose(done) {
        this.clearObj(this.addInfo); // 清空新增数据
        done();
      },
      showInfo(obj){
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.infoDialogVisible = true;
      },
      handleRowDblClick(row, column, event) {

        this.addInfo =JSON.parse(JSON.stringify(row));
        this.infoDialogVisible = true;
      },
      edit(obj){
        this.dialogTitle = "意见反馈编辑";
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.dialogVisible = true;
      },
      pageInfo(){
        if (this.loading)  return; // 防止重复提交
        this.loading=true;
        axios.get('/feedback',{
          params: this.searchInfo
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          let page = result.data;
          this.total = page.total;
          this.tableData = page.list;
        }).catch(err => {
          console.log(err);
          this.loading=false;
        });
      },
    },filters: {
      showState(val){
        if (val == 1){
          return "已处理";
        }
        return "未处理"
      },
      consumerState(val){
        if (val){
          return "禁用";
        }
        return "开启"
      }
    }
  }
</script>
<style lang="less" scoped>
  .addInfoStyle div{
    line-height: 4;
    .el-input{
      margin-right: 15px;
      width: 200px;
    }
  }
</style>
